import { appendElement, appendElementIf } from '../../xml-helpers';
import {
  buildContributors,
  buildTitles,
  buildAbstracts,
  buildPages,
  buildDoiData,
  buildCitationList,
} from '../../builders';
import type { BookChapter } from '@generated/form-types/book';

/**
 * Appends a `<content_item component_type="chapter">` element to the parent.
 *
 * XSD element order: contributors, titles, abstract, component_number,
 * publication_date, acceptance_date, pages, ..., doi_data, citation_list
 */
export function buildChapter(
  parent: Element,
  chapter: BookChapter,
  removeReferences = false
): Element {
  const contentItem = appendElement(parent, 'content_item', null, {
    component_type: 'chapter',
  });

  // 1. contributors (optional)
  if (chapter.contributors && chapter.contributors.length > 0) {
    buildContributors(contentItem, chapter.contributors);
  }

  // 2. titles
  buildTitles(contentItem, chapter.chapterTitle);

  // 3. abstracts (optional)
  buildAbstracts(contentItem, chapter.abstracts);

  // 4. component_number (optional)
  appendElementIf(
    contentItem,
    'component_number',
    chapter.pageOrChapterNumber?.chapterNumber
  );

  // 5. pages (optional)
  buildPages(contentItem, chapter.pageOrChapterNumber?.firstPageNumber);

  // 6. doi_data (required)
  buildDoiData(contentItem, chapter.doi, chapter.landingPageUrl);

  // 7. citation_list (optional)
  buildCitationList(contentItem, chapter.references, removeReferences);

  return contentItem;
}
